import { CHALLAN_TEXT, CHALLAN_TEXT_DEFAULT } from './challanConstants'

export const getChallanText = (challanLength, challanAmount) => (challanLength > 0 && challanAmount > 0)
    ? CHALLAN_TEXT(challanLength, challanAmount)
    : CHALLAN_TEXT_DEFAULT

export const getVariantId = (assetData) => {
  if (Array.isArray(assetData?.variant_id) && assetData?.variant_id?.length > 0) {
    return assetData?.variant_id[0]
  }

  if (Array.isArray(assetData?.vehicle?.variant_id) && assetData?.vehicle?.variant_id?.length > 0) {
    return assetData?.vehicle?.variant_id[0]
  }

  return null
}
